export const environment = {
  mobileBreakpoint: "600px",
  production: true,
  teamAssetsUrl: "https://realmadrid-static.geographica.gs",
  teamUrl:
    "https://publish-p47754-e237306.adobeaemcloud.com/content/dam/common/statics/public-content/badge/basket",
  playerUrl: "https://publish-p47754-e237306.adobeaemcloud.com/players/basket",
  carto: {
    envPrefix: "stg_",
    tablePreffix: "carto-ps-realmadrid-eu-stg.stg.",
    baseUrl: "https://gcp-europe-west1.api.carto.com/v3/sql",
    connection: "stg_read_app",
    public_access_token:
      "eyJhbGciOiJIUzI1NiJ9.eyJhIjoiYWNfYnkzNzdhNTEiLCJqdGkiOiI0OWMyODFiMSJ9.MRlc2EHiCPSXx1gNFrMGHqE0YUUk9uy2yUuliUcgDV0",
  },
};
